// ============================================================================
// view.broilerHome — the broiler dashboard, read locally
// ============================================================================
// /broiler rendered from TWO former-eager boot results reached through two
// provider hooks: the ppp-v4 broiler batch blob off BatchesContext, and the
// COMPLETE poultry_dailys history off DailysRecentContext.
// broiler.home.core owns both now, which is what lets `broilerHome` retire from
// the frozen app_store and poultry_dailys consumer lists in
// tests/fixtures/former-eager-dependencies.json.
//
// THE HISTORY IS COMPLETE, NOT WINDOWED, AND THAT IS A DELIBERATE COST.
//
// Every per-batch feed and mortality total on this page matches daily rows by
// `batch_label` alone, with no date bound — calcBroilerStatsFromDailys does the
// same. A recent-N-days window would therefore not "load less"; it would
// silently shrink the totals of every batch older than the window, on a page
// whose entire purpose is comparing batches over time. So the resource
// reproduces loadAllPoultryDailys' full pagination, narrowed to the six columns
// this surface actually reads.
//
// WHY THERE IS NO RESIDUAL.
//
// `setView` off UIContext is still called, and it is a navigation write, not a
// read; the provenance derivation scores setters as non-consuming. Nothing else
// on this surface touches a provider that the global boot fills.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.broilerHome',
  obligations: Object.freeze([Object.freeze({id: 'broiler.home.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
